import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IFalgExam } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const AddFalgExamSlice = createSlice({
  name: "AddFalgExamSlice",
  initialState: {} as IReduxState<IFalgExam>,
  reducers: {
    addFalgExam: (state, _: PayloadAction<IFalgExam>) => {
      state.isLoading = true;
    },
    successaddFalgExam: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddFalgExam: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddFalgExamResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addFalgExam,
  failureaddFalgExam,
  successaddFalgExam,
  clearAddFalgExamResponse,
} = AddFalgExamSlice.actions;

export default AddFalgExamSlice.reducer;
